class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

      if (window.infiniteScrollInstance) {
        window.infiniteScrollInstance.meetProductDestroy();
      }

      window.infiniteScrollInstance = new MeetAjaxForProduct({
        container: '#product-grid',
        pagination: '.infinite_next',
        method: 'scroll'
      });
  }

  static renderProductCount(html) {
    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    const parsedCountEl = parsedDoc.getElementById('ProductCount');

    // Exit early if count element is missing
    if (!parsedCountEl) return;

    const count = Number(parsedCountEl.innerHTML);

    // Exit if count is not a valid number
    if (Number.isNaN(count)) return;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );

    loadingSpinners.forEach(spinner => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


class FilterView extends HTMLElement {
  constructor() {
    super();
  }

  runActiveView() {
    const activeBtn = this.querySelector("button.active");
    if (!activeBtn) return;

    this.handleFilterClick({
      isModelView: activeBtn.hasAttribute("model-view"),
      isDefaultView: activeBtn.hasAttribute("default-view")
    });
  }


  connectedCallback() {
    const buttons = this.querySelectorAll("button");

    // Add listeners to ALL buttons
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const isModelView = btn.hasAttribute("model-view");
        const isDefaultView = btn.hasAttribute("default-view");

        // Save selected view in sessionStorage
        if (isModelView) sessionStorage.setItem("selected_view", "model-view");
        if (isDefaultView) sessionStorage.setItem("selected_view", "default-view");

        // Update "active" class
        buttons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        this.handleFilterClick({ isModelView, isDefaultView });
      });
    });

  }

  handleFilterClick({ isModelView, isDefaultView }) {
    const productCards = document.querySelectorAll("[card-product-grid]");

    productCards.forEach(card => {
      const productId = card.dataset.productId;
      if (!productId) return;

      const form = card.querySelector("form");
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value;

      const variantData = this.getVariantData(productId);
      if (!variantData || !variantData[variantId]) return;

      const variant = variantData[variantId];

      const checked_input = card.querySelector("input:checked");
      if(!checked_input) return;

      // MODEL VIEW
      if (isModelView && variant.model_image_url) {
        const images = card.querySelectorAll(`card-product-slider img[data-color="${checked_input.value}"][data-variant-index="true"]`);
        if (!images.length) return;
        images.forEach(img => {
          img.dataset.originalSrc = img.src;
          img.src = variant.model_image_url;
        });
      }

      // DEFAULT VIEW
      if (isDefaultView) {
        const images = card.querySelectorAll(`card-product-slider img[data-color="${checked_input.value}"][data-variant-index="true"]`);
        if (!images.length) return;
        images.forEach(img => {
          if (img.dataset.originalSrc) {
            console.log("img.dataset.originalSrc----true", img.dataset.originalSrc)
            img.src = img.dataset.originalSrc;
          }
        });
      }
    });
  }

  getVariantData(productId) {
    const scriptTag = document.querySelector(
      `script[data-product-id="${productId}"]`
    );
    if (!scriptTag) return null;

    const scriptContent = scriptTag.textContent;
    const match = scriptContent.match(
      /var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/
    );
    if (!match) return null;

    let jsonString = match[1];

    try {
      jsonString = jsonString
        .replace(/(\w+):/g, '"$1":')
        .replace(/,(\s*[}\]])/g, "$1");

      return JSON.parse(jsonString);
    } catch (err) {
      console.error("Variant map parse error:", productId, err);
      return null;
    }
  }
}
customElements.define("filter-view", FilterView);

class PriceRangeCustom extends HTMLElement {
  constructor() {
    super();
    // DOM references
    this.minThumb = this.querySelector('#min-thumb');
    this.maxThumb = this.querySelector('#max-thumb');
    this.minValue = this.querySelector('#min-value');
    this.maxValue = this.querySelector('#max-value');
    this.sliderRange = this.querySelector('.slider-range');
    this.sliderContainer = this.querySelector('.slider-container');

    this.minInput = this.querySelector('#price-min-input');
    this.maxInput = this.querySelector('#price-max-input');

    // Dataset values
    this.minPrice = parseInt(this.dataset.minPrice);
    this.maxPrice = parseInt(this.dataset.maxPrice);
    this.currencySymbol = this.dataset.currencySymbol;

    // State
    this.currentMinVal = this.minPrice;
    this.currentMaxVal = this.maxPrice;
    this.activeThumb = null;
    this.isDragging = false;
  }

  connectedCallback() {
    this.initializeSliderFromURL();

    // Mouse support
    this.minThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.maxThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));

    // Sync from mobile
    window.addEventListener('price-range-updated', (e) => {
      if (e.detail.source !== 'desktop') {
        this.setValues(e.detail.min, e.detail.max, false);
      }
    });
  }

  initializeSliderFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const minParam = urlParams.get('filter.v.price.gte');
    const maxParam = urlParams.get('filter.v.price.lte');
    if (minParam !== null) this.currentMinVal = parseInt(minParam);
    if (maxParam !== null) this.currentMaxVal = parseInt(maxParam);
    this.setValues(this.currentMinVal, this.currentMaxVal, false);
  }

  setValues(minVal, maxVal, dispatch = true) {
    const minPercent = ((minVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    const maxPercent = ((maxVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;

    this.minThumb.style.left = `${minPercent}%`;
    this.maxThumb.style.left = `${maxPercent}%`;
    this.sliderRange.style.left = `${minPercent}%`;
    this.sliderRange.style.width = `${maxPercent - minPercent}%`;

    this.currentMinVal = minVal;
    this.currentMaxVal = maxVal;

    this.minValue.textContent = `${this.currencySymbol}${minVal}`;
    this.maxValue.textContent = `${this.currencySymbol}${maxVal}`;

    this.minValue.style.left = `${minPercent}%`;
    this.maxValue.style.left = `${maxPercent}%`;

    if (this.minInput) this.minInput.value = minVal;
    if (this.maxInput) this.maxInput.value = maxVal;

    if (dispatch) {
      window.dispatchEvent(new CustomEvent('price-range-updated', {
        detail: { min: minVal, max: maxVal, source: 'desktop' }
      }));
    }
  }

  updateURL() {
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      const searchParams = new URLSearchParams(new FormData(form.querySelector('form')));
      FacetFiltersForm.renderPage(searchParams.toString());
    }
  }

  handleMouseDown(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('mousemove', this.handleMouseMoveBound = this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUpBound = this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }
    this.updateSlider();
  }

  updateSlider() {
    const minPercent = parseFloat(this.minThumb.style.left);
    const maxPercent = parseFloat(this.maxThumb.style.left);
    const minVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * minPercent / 100);
    const maxVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * maxPercent / 100);
    this.setValues(minVal, maxVal, true);
  }

  handleMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('mousemove', this.handleMouseMoveBound);
      document.removeEventListener('mouseup', this.handleMouseUpBound);
      this.updateURL();
    }
  }
}
customElements.define('price-range-custom', PriceRangeCustom);

class PriceRangeCustomMobile extends HTMLElement {
  constructor() {
    super();
    // DOM references
    this.minThumb = this.querySelector('#min-thumb_2');
    this.maxThumb = this.querySelector('#max-thumb_2');
    this.minValue = this.querySelector('#min-value_2');
    this.maxValue = this.querySelector('#max-value_2');
    this.sliderRange = this.querySelector('.slider-range_2');
    this.sliderContainer = this.querySelector('.slider-container_2');

    this.minInput = this.querySelector('#price-min-input');
    this.maxInput = this.querySelector('#price-max-input');

    // Dataset values
    this.minPrice = parseInt(this.dataset.minPrice);
    this.maxPrice = parseInt(this.dataset.maxPrice);
    this.currencySymbol = this.dataset.currencySymbol;

    // State
    this.currentMinVal = this.minPrice;
    this.currentMaxVal = this.maxPrice;
    this.activeThumb = null;
    this.isDragging = false;
  }

  connectedCallback() {
    this.initializeSliderFromURL();

    // Mouse support
    this.minThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.maxThumb.addEventListener('mousedown', this.handleMouseDown.bind(this));

    // Touch support
    this.minThumb.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
    this.maxThumb.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });

    // Sync from desktop
    window.addEventListener('price-range-updated', (e) => {
      if (e.detail.source !== 'mobile') {
        this.setValues(e.detail.min, e.detail.max, false);
      }
    });
  }

  initializeSliderFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const minParam = urlParams.get('filter.v.price.gte');
    const maxParam = urlParams.get('filter.v.price.lte');
    if (minParam !== null) this.currentMinVal = parseInt(minParam);
    if (maxParam !== null) this.currentMaxVal = parseInt(maxParam);
    this.setValues(this.currentMinVal, this.currentMaxVal, false);
  }

  setValues(minVal, maxVal, dispatch = true) {
    const minPercent = ((minVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    const maxPercent = ((maxVal - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;

    this.minThumb.style.left = `${minPercent}%`;
    this.maxThumb.style.left = `${maxPercent}%`;
    this.sliderRange.style.left = `${minPercent}%`;
    this.sliderRange.style.width = `${maxPercent - minPercent}%`;

    this.currentMinVal = minVal;
    this.currentMaxVal = maxVal;

    // this.minValue.textContent = `${this.currencySymbol}${minVal}`;
    // this.maxValue.textContent = `${this.currencySymbol}${maxVal}`;

    this.minValue.style.left = `${minPercent}%`;
    this.maxValue.style.left = `${maxPercent}%`;

    if (this.minInput) this.minInput.value = minVal;
    if (this.maxInput) this.maxInput.value = maxVal;

    if (dispatch) {
      window.dispatchEvent(new CustomEvent('price-range-updated', {
        detail: { min: minVal, max: maxVal, source: 'mobile' }
      }));
    }
  }

  updateURL() {
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) {
      const searchParams = new URLSearchParams(new FormData(form.querySelector('form')));
      FacetFiltersForm.renderPage(searchParams.toString());
    }
  }

  // Mouse handlers
  handleMouseDown(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('mousemove', this.handleMouseMoveBound = this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUpBound = this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }
    this.updateSlider();
  }

  handleMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('mousemove', this.handleMouseMoveBound);
      document.removeEventListener('mouseup', this.handleMouseUpBound);
      this.updateURL();
    }
  }

  // Touch handlers
  handleTouchStart(e) {
    this.activeThumb = e.target;
    this.isDragging = true;
    document.addEventListener('touchmove', this.handleTouchMoveBound = this.handleTouchMove.bind(this), { passive: false });
    document.addEventListener('touchend', this.handleTouchEndBound = this.handleTouchEnd.bind(this));
    e.preventDefault();
  }

  handleTouchMove(e) {
    if (!this.isDragging || !this.activeThumb) return;
    e.preventDefault();
    const touch = e.touches[0];
    const rect = this.sliderContainer.getBoundingClientRect();
    const percent = Math.max(0, Math.min(100, ((touch.clientX - rect.left) / rect.width) * 100));

    if (this.activeThumb === this.minThumb) {
      const maxPercent = parseFloat(this.maxThumb.style.left);
      this.minThumb.style.left = `${Math.min(percent, maxPercent)}%`;
    } else {
      const minPercent = parseFloat(this.minThumb.style.left);
      this.maxThumb.style.left = `${Math.max(percent, minPercent)}%`;
    }

    this.updateSlider();
  }

  handleTouchEnd() {
    if (this.isDragging) {
      this.isDragging = false;
      this.activeThumb = null;
      document.removeEventListener('touchmove', this.handleTouchMoveBound);
      document.removeEventListener('touchend', this.handleTouchEndBound);
      this.updateURL();
    }
  }

  updateSlider() {
    const minPercent = parseFloat(this.minThumb.style.left);
    const maxPercent = parseFloat(this.maxThumb.style.left);
    const minVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * minPercent / 100);
    const maxVal = Math.round(this.minPrice + (this.maxPrice - this.minPrice) * maxPercent / 100);
    this.setValues(minVal, maxVal, true);
  }
}
customElements.define('price-range-custom-mobile', PriceRangeCustomMobile);